import {gsap} from "../LibrariesImport";
import {ScrollTrigger} from "../LibrariesImport";

export default class BlockTimeline {
    constructor() {
        this.timelines = document.querySelectorAll(".block-timeline");
        if (this.timelines.length > 0) {
            this.initTimelines();
        }
    }

    initTimelines() {
        this.timelines.forEach((timeline) => {
            const containerElement = timeline.querySelector('.line-container');
            const lineElement = timeline.querySelector('.line');
            const dots = timeline.querySelectorAll('.dot');
            const events = timeline.querySelectorAll('.event');
            const slider = timeline.querySelector('.swiper');

            const swiper = new Swiper(slider, {
                slidesPerView: "auto",
                autoHeight: true,
                allowTouchMove: false,
                direction: "vertical",
                spaceBetween: 12,
                speed: 600,
            });

            if (!lineElement || !containerElement) {
                return;
            }

            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (!prefersReducedMotion) {
                const lineTimeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: containerElement,
                        start: "top center",
                        end: "bottom center",
                        scrub: true,
                    }
                });

                lineTimeline.to(lineElement, {
                    height: "100%",
                    ease: "none"
                });

                dots.forEach((dot) => {
                    const dotTimeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: dot,
                            start: "center center+=10",
                            end: "center center-=10",
                            scrub: true,
                        }
                    });

                    dotTimeline.to(dot, {
                        opacity: 1,
                        scale: 1.5,
                        ease: "none"
                    });
                });
            } else {
                lineElement.style.height = '100%';
                dots.forEach(dot => { dot.style.opacity = '1'; });
            }

            events.forEach((event) => {
                ScrollTrigger.create({
                    trigger: event,
                    start: "top center",
                    end: "bottom center",

                    onEnter: () => {
                        event.classList.add("active");
                    },
                    onEnterBack: () => {
                        event.classList.add("active");
                    },
                    onLeave: () => {
                        event.classList.remove("active");
                    },
                    onLeaveBack: () => {
                        event.classList.remove("active");
                    },
                });

                event.addEventListener('focus', () => {
                    event.classList.add('active');
                    const parentPeriod = event.closest('.timeline-period-container');
                    if (parentPeriod) {
                        const periodIndex = parseInt(parentPeriod.dataset.period, 10) - 1;
                        if (swiper.activeIndex !== periodIndex) {
                            swiper.slideTo(periodIndex);
                        }
                    }
                });

                event.addEventListener('blur', () => {
                    event.classList.remove('active');
                });
            });

            // 2. Pilotage du Swiper via les périodes
            const periodContainers = timeline.querySelectorAll('.timeline-period-container');

            periodContainers.forEach((period, index) => {
                const periodIndex = parseInt(period.dataset.period, 10) - 1; // Le data-period commence à 1, l'index Swiper commence à 0.

                // Création d'un ScrollTrigger pour chaque période
                ScrollTrigger.create({
                    trigger: period,
                    start: "top center",
                    end: "bottom center",

                    onEnter: () => {
                        if (swiper.activeIndex !== periodIndex) {
                            swiper.slideTo(periodIndex);
                        }
                    },
                    onEnterBack: () => {
                        if (swiper.activeIndex !== periodIndex) {
                            swiper.slideTo(periodIndex);
                        }
                    },
                });
            });
        });
    }
}